module.exports = __webpack_public_path__ + "images/interview-Amazon_Web_Services-2.svg";